export interface Threshold {
  label: string;
  test: (value: number) => boolean;
}

export interface KpiItem {
  key: string;
  name: string;
  unit?: string;
  multiplier?: number;
  warning: Threshold;
  danger: Threshold;
}

export const getStatusColor = (value: number | undefined | null, danger: Threshold, warning: Threshold): string => {
  if (!value) {
    return "grey";
  } else if (danger.test(value)) {
    return "red";
  } else if (warning.test(value)) {
    return "orange";
  } else {
    return "green";
  }
};

export const KPI_ITEMS_AEROHIVE: KpiItem[] = [
  {
    key: "DHCP",
    name: "Kpi.Aerohive.DHCP",
    unit: "%",
    warning: { label: "< 98", test: (value) => value < 98 },
    danger: { label: "< 90", test: (value) => value < 90 },
  },
  {
    key: "MOSVOIPDOWN",
    name: "Kpi.Aerohive.MOSVOIPDOWN",
    unit: "MOS",
    warning: { label: "< 4.0", test: (value) => value < 4.0 },
    danger: { label: "< 3.6", test: (value) => value < 3.6 },
  },
  {
    key: "MOSVOIPUP",
    name: "Kpi.Aerohive.MOSVOIPUP",
    unit: "MOS",
    warning: { label: "< 4.0", test: (value) => value < 4.0 },
    danger: { label: "< 3.6", test: (value) => value < 3.6 },
  },
  {
    key: "RADIUS",
    name: "Kpi.Aerohive.RADIUS",
    unit: "%",
    warning: { label: "< 98", test: (value) => value < 98 },
    danger: { label: "< 90", test: (value) => value < 90 },
  },
  {
    key: "THROUGHPUTDOWN",
    name: "Kpi.Aerohive.THROUGHPUTDOWN",
    unit: "Mbit/s",
    warning: { label: "< 49", test: (value) => value < 49 },
    danger: { label: "< 45", test: (value) => value < 45 },
  },
  {
    key: "THROUGHPUTUP",
    name: "Kpi.Aerohive.THROUGHPUTUP",
    unit: "Mbit/s",
    warning: { label: "< 49", test: (value) => value < 49 },
    danger: { label: "< 45", test: (value) => value < 45 },
  },
];

export const KPI_ITEMS_ARUBA: KpiItem[] = [
  {
    key: "WIFI_ASSOC_TIME",
    name: "Kpi.Aruba.WIFI_ASSOC_TIME",
    unit: "s",
    warning: { label: "> 4", test: (value) => value > 4.0 },
    danger: { label: "> 5", test: (value) => value > 5.0 },
  },
  {
    key: "DHCP_RES_TIME",
    name: "Kpi.Aruba.DHCP_RES_TIME",
    unit: "s",
    warning: { label: "> 5", test: (value) => value > 5 },
    danger: { label: "> 10", test: (value) => value > 10 },
  },
  {
    key: "DNS_RES_TIME",
    name: "Kpi.Aruba.DNS_RES_TIME",
    unit: "ms",
    multiplier: 1000,
    warning: { label: "> 50", test: (value) => value > 50 },
    danger: { label: "> 100", test: (value) => value > 100 },
  },
  {
    key: "RADIUS",
    name: "Kpi.Aruba.RADIUS",
    unit: "s",
    warning: { label: "> 10", test: (value) => value > 10 },
    danger: { label: "> 15", test: (value) => value > 15 },
  },
  {
    key: "VOICE_QUALITY",
    name: "Kpi.Aruba.VOICE_QUALITY",
    unit: "MOS",
    warning: { label: "< 4.0", test: (value) => value < 4.0 },
    danger: { label: "< 3.6", test: (value) => value < 3.6 },
  },
  {
    key: "THROUGHPUT_DOWN",
    name: "Kpi.Aruba.THROUGHPUT_DOWN",
    unit: "Mbit/s",
    warning: { label: "< 49", test: (value) => value < 49 },
    danger: { label: "< 45", test: (value) => value < 45 },
  },
  {
    key: "THROUGHPUT_UP",
    name: "Kpi.Aruba.THROUGHPUT_UP",
    unit: "Mbit/s",
    warning: { label: "< 49", test: (value) => value < 49 },
    danger: { label: "< 45", test: (value) => value < 45 },
  },
];
